<template>
    <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 11.3 11.3"
        style="enable-background: new 0 0 11.3 11.3"
        xml:space="preserve"
    >
        <path
            class="st0"
            d="M-16.9,34.4h-5.4c-0.3,0-0.5-0.1-0.6-0.3l-0.7-1c-0.5-0.7-1.3-1.2-2.1-1.2h-3.7c-1.4,0-2.6,1.2-2.6,2.6v10
	c0,1.4,1.2,2.6,2.6,2.6h7.1c0-0.2-0.1-0.3-0.1-0.5c0-0.2,0-0.3-0.1-0.5c0-0.1,0-0.1,0-0.2c0-2.9,2.4-5.2,5.2-5.2
	c0.6,0,1.3,0.1,1.8,0.3c0.2,0.1,0.3,0.1,0.5,0.2c0.2,0.1,0.3,0.2,0.5,0.3V37C-14.3,35.6-15.4,34.4-16.9,34.4z"
        />
        <polygon class="st0" points="-15.3,44.4 -15.3,44.4 -15.3,44.4 " />
        <path
            class="st0"
            d="M-14.3,42.1c-0.2-0.1-0.3-0.2-0.5-0.3c-0.2-0.1-0.3-0.2-0.5-0.3c-0.6-0.2-1.2-0.4-1.8-0.4
	c-2.6,0-4.8,2.1-4.8,4.7c0,0.1,0,0.1,0,0.2c0,0.2,0,0.3,0.1,0.5c0,0.2,0.1,0.3,0.1,0.5c0.5,2.1,2.4,3.6,4.6,3.6
	c2.6,0,4.8-2.1,4.8-4.8C-12.4,44.3-13.1,43-14.3,42.1z M-18.6,48.1l-0.7-0.7l0.3-0.3l0.5-0.5l0.5-0.5l0.2-0.2l-1.5-1.5l0.7-0.7
	l1.5,1.5l1.5-1.5l0.3,0.3l0.4,0.4l-0.4,0.4l-1.1,1.1l0.1,0.1l0.4,0.4l0.4,0.4l0.7,0.7l-0.7,0.7l-1.1-1.1l-0.4-0.4l-0.5,0.5
	L-18.6,48.1z"
        />
        <path
            class="st1"
            d="M66.5,47.7c1.1,0,2.2,0.4,3,1c0.6-1.5,1-3,1-4.7c0-6.6-5.4-12-12-12c-6.6,0-12,5.4-12,12c0,6.6,5.4,12,12,12
	c1.2,0,2.3-0.2,3.4-0.5c-0.4-0.7-0.7-1.6-0.7-2.5C61.2,50,63.6,47.7,66.5,47.7z"
        />
        <path
            class="st0"
            d="M69.3,49.1c-0.8-0.6-1.8-0.9-2.8-0.9c-2.6,0-4.8,2.1-4.8,4.8c0,0.9,0.2,1.6,0.6,2.3c0.8,1.4,2.3,2.4,4.1,2.4
	c2.6,0,4.8-2.1,4.8-4.8C71.2,51.3,70.5,50,69.3,49.1z M67.2,52.9l1.5,1.5L68,55.1l-1.5-1.5L65,55.1l-0.7-0.7l0,0l1.5-1.5l-1.5-1.5
	l0.7-0.7l1.5,1.5l1.5-1.5l0.2,0.2l0.5,0.5L67.2,52.9z"
        />
        <path
            class="st0"
            d="M0.7,5.7c0-2.8,2.2-5,5-5s5,2.2,5,5s-2.2,5-5,5S0.7,8.4,0.7,5.7z M4.2,3.5L3.5,4.2L5,5.7L3.5,7.2l0.7,0.7
	l1.5-1.5l1.5,1.5l0.7-0.7L6.4,5.7l1.5-1.5L7.2,3.5L5.7,5L4.2,3.5z"
        />
        <g>
            <defs>
                <rect
                    id="SVGID_1_"
                    x="51.7"
                    y="37.5"
                    width="13.3"
                    height="13.3"
                />
            </defs>
            <clipPath
                id="SVGID_00000155828186968797038250000005819065723933631120_"
            >
                <use xlink:href="#SVGID_1_" style="overflow: visible" />
            </clipPath>
            <g
                style="
                    clip-path: url(#SVGID_00000155828186968797038250000005819065723933631120_);
                "
            >
                <path
                    class="st3"
                    d="M60.9,45.2l1.5,1.5l-4.1,4.1l-4.1-4.1l1.5-1.5l2.6,2.6L60.9,45.2z M63.5,42.6l1.5,1.5l-1.5,1.5L62,44.1
			L63.5,42.6z M58.3,42.6l1.5,1.5l-1.5,1.5l-1.5-1.5L58.3,42.6L58.3,42.6z M53.2,42.6l1.5,1.5l-1.5,1.5l-1.5-1.5L53.2,42.6z
			 M58.3,37.5l4.1,4.1l-1.5,1.5l-2.6-2.6l-2.6,2.6l-1.5-1.5L58.3,37.5L58.3,37.5z"
                />
            </g>
        </g>
    </svg>
</template>
